import win from "../win_util";

export default function initOneSignal() {
  if (!win) return;

  var s = document.createElement("script");
  s.type = "text/javascript";
  s.src = "https://cdn.onesignal.com/sdks/OneSignalSDK.js";
  document.body.appendChild(s);

  window.OneSignal = window.OneSignal || [];
  window.dataLayer = window.dataLayer || [];
  window.OneSignal.push(function () {
    console.log("OneSignal - init");
    window.OneSignal.init({
      appId: process.env.GATSBY_ONE_SIGNAL_APP_ID,
    });
  });
  window.OneSignal.push(function () {
    console.log("OneSignal.on('subscriptionChange')");
    window.OneSignal.on("subscriptionChange", function (isSubscribed) {
      if (isSubscribed == true) {
        window.OneSignal.getUserId()
          .then(function (userId) {
            console.log("isSubscribed==true / userid = " + userId);
            window.dataLayer.push({ event: "Accept_PN" });
          })
          .then(function () {
            //send to server?
          });
      } else if (isSubscribed == false) {
        window.OneSignal.getUserId().then(function (userId) {
          console.log("isSubscribed==false / userid = " + userId);
        });
      } else {
        console.error("Unable to process the request");
      }
    });
  });
  window.OneSignal.push(function () {
    // If we're on an unsupported browser, do nothing
    if (!window.OneSignal.isPushNotificationsSupported()) {
      console.log("OneSignal unsupported browser");
      return;
    }
    window.OneSignal.on("subscriptionChange", function (isSubscribed) {
      console.log(
        "OneSignal subscription changed! isSubscribed is now:" + isSubscribed
      );
      //https://documentation.onesignal.com/docs/web-push-sdk#section--getnotificationpermission-
      // IMPORTANT?? https://documentation.onesignal.com/docs/web-push-sdk#section--custompromptclick-
    });
  });
  window.OneSignal.push(function () {
    window.OneSignal.getUserId().then(function (userId) {
      console.log("OneSignal User ID:", userId);
    });
  });
  window.OneSignal.push(function () {
    window.OneSignal.on(
      "notificationPermissionChange",
      function (permissionChange) {
        var currentPermission = permissionChange.to;
        console.log(
          "The user interacted with the native browser's permission dialog. Permission state is now ('granted'=allow, 'denied'=blocked, 'default'=user clicked x to dismiss the prompt): " +
            currentPermission
        );
        window.dataLayer.push({ event: "Accept_PN" });
      }
    );
  });
}

// export default {
//   initOneSignal,
// };
